import { useEffect } from 'react';
import { useLocation } from '@/router/routerCompat';

/**
 * Scrolls the window to top when the route (pathname) changes.
 * Place once inside the Router (e.g. in AppLayout).
 */
export function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
